import { useRouter } from 'next/router';

import { FormField, FormHelp, Label, Select } from '@zillow/constellation-10';

import { useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import { bathOptions } from '@zg-rentals/zillow-rental-manager/constants';

import { useScreenSize } from '../../../hooks';
import { setFloorPlanField } from '../../../hooks/queries/listingDetailsCache';
import { useGetListingDetails } from '../../../hooks/queries/properties';
import { useFieldSave } from '../../../hooks/useFieldSave';
import { usePropertyEditMutation } from '../../../hooks/usePropertyEditMutation';

const inputName = 'numBathrooms';

const BathroomsFormField = () => {
  const router = useRouter();
  const { isScreenDesktop } = useScreenSize();

  const listingAlias = router.query.listingAlias as string;
  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const floorPlans = listingDetails?.floorPlans || [];
  const floorPlanId = floorPlans[0]?.id;
  const initialBathrooms = floorPlans[0]?.numBathrooms;

  let bathOptionsValues = bathOptions;

  if (initialBathrooms !== undefined) {
    bathOptionsValues = bathOptions.slice(1);
  }

  const updateMutation = usePropertyEditMutation({
    mutationHook: useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms,
    applyToCache: ({ postData }) => [
      setFloorPlanField(postData.floorPlanId, 'numBathrooms', postData.numBathrooms ?? null),
    ],
    meta: { context: { api: 'RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms' } },
  });

  const bathroomsField = useFieldSave({
    fieldName: inputName,
    initialValue: initialBathrooms,
    mutation: updateMutation,
    buildMutationVariables: (value) =>
      floorPlanId ? { postData: { floorPlanId, numBathrooms: Number(value) } } : null,
  });

  return (
    <FormField
      data-testid="BathroomsFormField"
      required={true}
      label={<Label>Total bathrooms</Label>}
      control={
        <Select
          size={isScreenDesktop ? 'lg' : 'md'}
          name={inputName}
          value={String(bathroomsField.value)}
          onChange={(e) => bathroomsField.onChange(Number(e.target.value))}
          onBlur={bathroomsField.onBlur}
          required={true}
          css={{ whiteSpace: 'pre' }}
        >
          {bathOptionsValues.map((option) => {
            if (option === '10+') {
              return (
                <option key={option} value={10}>
                  {option}
                </option>
              );
            }
            return (
              <option key={option} value={option} disabled={option === ''}>
                {option || 'Select'}
              </option>
            );
          })}
        </Select>
      }
      error={!!bathroomsField.error}
      description={<FormHelp>{bathroomsField.error}</FormHelp>}
    />
  );
};

export default BathroomsFormField;
